const appendElementAsLastChildOfBody = (element) =>
  document.body.insertBefore(element, document.body.lastElementChild.nextElementSibling);

export { appendElementAsLastChildOfBody };
